var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7796 0.157503C12.0506 0.399404 12.0751 0.820824 11.8341 1.09374L5.04913 8.77687C4.80685 9.05121 4.39085 9.06866 4.12732 8.81558L0.201079 5.04466C-0.0437739 4.80948 -0.0672125 4.41762 0.142863 4.14972C0.374668 3.85411 0.806338 3.81343 1.08221 4.06657L4.12844 6.86198C4.39317 7.10492 4.80075 7.08319 5.03926 6.81345L10.8753 0.211964C11.1115 -0.0551793 11.5142 -0.0793946 11.7796 0.157503Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkWhite);
export default __webpack_public_path__ + "static/media/CheckmarkWhite.4baf004cb7debaa858c4f65477354abf.svg";
export { ForwardRef as ReactComponent };